import { render, staticRenderFns } from "./project-documents-manual.vue?vue&type=template&id=f1ff60b8&scoped=true"
import script from "./project-documents-manual.vue?vue&type=script&lang=js"
export * from "./project-documents-manual.vue?vue&type=script&lang=js"
import style0 from "./project-documents-manual.vue?vue&type=style&index=0&id=f1ff60b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ff60b8",
  null
  
)

export default component.exports